import { Button, FlexBox } from '@Backlot-Cars/archie';

export const LookupActions = ({ onContinueManually, onTryAgain, tryAgainCopy, continueManuallyCopy }) => (
	<FlexBox alignItems="center" flexDirection="row-reverse" gap="sm" justifyContent="space-between" width="100%">
		{onTryAgain && (
			<Button type="button" onClick={onTryAgain}>
				{tryAgainCopy}
			</Button>
		)}
		<Button type="button" variant="tertiary" onClick={onContinueManually}>
			{continueManuallyCopy}
		</Button>
	</FlexBox>
);
